import omit from 'lodash/omit';
import { apiSlice } from '../../../app/services/apiSlice';

const REASON_URL = 'decline-reasons';

export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    addNewReason: builder.mutation({
      query: (data) => ({
        url: `${REASON_URL}`,
        method: 'POST',
        body: {
          ...data,
        },
      }),
    }),
    updateReason: builder.mutation({
      query: (data) => ({
        url: `${REASON_URL}/${data?.id}`,
        method: 'PUT',
        body: omit(data,'id')
      }),
    }),

    getAllReasons: builder.query({
      query: (params) => ({
        url: `${REASON_URL}`,
        params,
      }),
    }),

    getReasons: builder.mutation({
      query: (params) => ({
        url: `${REASON_URL}`,
        method: 'GET',
        params
      }),
      transformResponse: (responseData) => {
        responseData.options = responseData?.declineReasons?.map((reason) => ({
          ...reason,
          title: reason?.text,
          value: reason?.id,
        }));
        return responseData || {};
      },
    }),

    deleteReason: builder.mutation({
      query: (params) => ({
        url: `${REASON_URL}/${params}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useAddNewReasonMutation,
  useUpdateReasonMutation,
  useGetAllReasonsQuery,
  useDeleteReasonMutation,
  useGetReasonsMutation
} = extendedApiSlice;
